<template>
  <div>
    <div class="modalDiv" v-if="addshow">
      <div class="modaView">
        <div class="modatitle">充值声明</div>
        <div class="modalcontainer" @scroll="handleScroll">
          <div style="height: 18rem;width: 96%;margin-left: 2%" class="shocoamer">
            <p>欢迎使用本公司物流在线服务。</p>
            <p>在您使用本服务前，请您认真阅读<u>在线服务协议</u>，若您同意，我们将严格根据和按照协议内容为您提供服务。</p>
            <p>&nbsp;</p>
            <h1 style="text-align: center;"><strong>在线服务协议</strong></h1>
            <p style="text-align: right;">更新日期：2024年12月01日<br />生效日期：2024年12月01日</p>
            <p><strong>引言</strong></p>
            <p>感谢您选择本公司在线服务<strong>（"本服务"）</strong>！我们尽可能全面地向您谨此提供在线服务协议<strong>（"本协议"）</strong>的内容，我们也希望您认真阅读且熟悉本协议各项条款。</p>
            <p>我们在此善意地提醒您，本协议中与您的权益会有重大关系的条款<strong>。</strong>如果您对本协议及本服务有任何问题、疑惑，请随时联系我们，我们为您提供了多种联系渠道，希望为您提供满意的反馈。</p>
            <ol>
              <li>1. 人工客服通道：您可以在工作日的工作时间（周一至周五：09:00-18:00）拨打我们的客服热线：86 400 800 7061；</li>
              <li>2. 专设的邮件通道：您可以通过发送电子邮件至dengqianhua@sjlexpress.com，通过电子邮件与我们联系；</li>
              <li>3. 点击本APP 首页的客服界面，留下您的需求，建议和您的联系电话等联系方式，工作时间我们会及时联系您。</li>
            </ol>
            <p><strong>除非您同意本协议的所有条款，否则您无权登录或使用任何</strong><strong>本</strong><strong>在线服务。若您登录、开启以及在开启本服务状态下进行本服务项下的任何物流等使用本服务的行为有可能在合理合法的情况下被我们视为您同意本协议全部条款，并同意受其约束。</strong></p>
            <p><strong>如果您因年龄、智力等各种因素而不具有完全民事行为能力，请在监护人的陪同下阅读和决定是否同意本协议。</strong></p>
            <p>&nbsp;</p>
            <p><strong>协议正文：</strong></p>
            <p><strong>一、在线服务</strong></p>
            <p>1.1.本服务是基于互联网技术提供的。本服务包括我们或我们的关联公司及/或与我们或我们的关联公司存在合作关系的第三方合作单位提供的供您以在线服务账号登录后使用的全部服务，具体物流服务以我们实际提供的为准。</p>
            <p>1.2.本服务项下的由我们提供的具体服务的服务名称、服务内容、服务期限、服务标准及服务项目数量等均以我们届时实际提供的为准。</p>
            <p>1.3.我们可能根据实际运营情况调整本服务的内容以及提供形式、充值和处理方式、对收费服务的服务费用的收费方式、收费标准进行修改和变更。前述修改、变更，我们会给与相关提示。</p>
            <p><strong>二、登录方式和程序管理</strong></p>
            <p>2.1.您通过注册账号登录本服务，则您按照注册页面提示填写信息、阅读并点击同意本协议且完成全部注册流程后，则您获得的账号即是您的在线服务账号。</p>
            <p>2..1.在线服务账号由您自行保管，若因为您自身行为或者非本公司行为导致您的在线服务账号、密码遭他人非法使用、攻击或您遭受诈骗等，由此产生的损失及后果，均由您自行承担。</p>
            <p>2.2. 请您在实名认证时务必谨慎对待，避免将本人使用的在线服务账号认证在他人名下等任何不当认证行为。我们有权根据法律规定和本协议约定随时要求您进行实名认证，您应当予以配合并向我们提供认证所需的相关资料，您同意本协议则视为您同意授权我们可以向第三方核实您的身份等信息。</p>
            <p>2.3.实名认证主体将被视为承诺对本在线服务账号下的一切行为负责的主体，若账号或账号下行为出现纠纷等情形，需由实名认证主体承担全部责任。若本公司发现您以不实信息骗取账号名称注册，或您的账号头像、简介等注册信息存在违法违规的，有权采取警示、限期改正、限制账号功能、暂停使用、注销登记、关闭账号、禁止重新注册、依法诉讼等措施。</p>
            <p><strong>2.4 </strong>您在点击接受本协议及本服务包含的具体服务附带的协议（若有）的全部内容后，则可使用物流在线服务账号接入本服务的部分或全部服务，获得本服务部分或全部服务的账户，成为本服务部分或全部服务的合法用户。</p>
            <p>2.5.若您的在线服务账号存在异常频繁登录、多次异常异地登录的情况及其它本公司认为异常情形，我们有权视情况冻结该在线服务账号,若有充值费用，可以登录首页要求退款。</p>
            <p><strong>三</strong><strong>,提供服务方式 </strong></p>
            <p>3.1一旦您点击要求我们提供物流服务，则我们根据本公司的正常流程提供物流服务，您的点击视为认可我们的物流服务流程，规则，收费标准等所有物流服务内容。</p>
            <p>3.2.本服务是按照我们现有技术和条件所能达到的条件提供的。我们无法担保我们所能提供的服务毫无瑕疵。但若我们提供的服务存在纰漏，但若所有纰漏是提供当时国内行业技术条件正常情况之下是无法避免的，不能视为我们违约。</p>
            <p>四，充值行为</p>
            <p>4.1.充值行为</p>
            <p>您可通过登录方式，根据平台提示进行服务费用充值，并享受充值时平台提示的优惠。</p>
            <p>此充值的金额视为登录账号项下的可冲抵物流服务费用。但是不得用于与本平台物流服务无关的其它费用，也不得要求平台转给任何第三方。不容许充值后转手倒卖、置换、抵押、有价交易等方式处理充值费用。一经发现，我们有权采取合适的方式予以处理。</p>
            <p>4.2,退费:</p>
            <p>若充值后无需相关物流服务，可以根据平台提示的联系方式以原路返回方式退还。退还方式是原路、无息返还。充值者在任何情形之下不得要求孳息和非原路返还的其它路径退款要求。若有违约金情况发生，我们在扣除违约金后退还余款。</p>
            <p>退款手续费将扣除后退还余款；</p>
            <p>4.3，充值上限：</p>
            <p>同一账号（如同一手机号、微信号）充值累计最高不得超过人民币5万元。</p>
            <p><strong>&nbsp;</strong></p>
            <p><strong>五，投诉渠道</strong></p>
            <p>5.1您可以根据引言提供的联系渠道，向我公司提出任何关于咨询、疑问，要求退费，要求提供物流服务等所有需求。</p>
            <p>5.2 若双方就本协议内容或其执行提供物流服务发生任何争议，您须首先以引言所列方式向我们投诉。而且双方首先通过本协议提示的联系方式友好协商解决。若协商不成，任何一方均可向公司办公所在地上海市长宁区人们法院提起诉讼.本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
            <p><strong>本公司接受所有通知、文件包括司法文件的地址为：上海市长宁区虹桥</strong><strong>路</strong><strong>2535</strong><strong>号</strong><strong>7</strong><strong>楼F座。</strong></p>
            <p><strong>5.3，任何不经投诉要求解决的而直接诉讼行为视为您违约，您须根据本协议6.5.3条承担我们的所有相关费用和名誉损失。</strong></p>
            <p><strong>六</strong><strong>、违约及处理</strong></p>
            <p>发生如下情形之一的，视为您违约：</p>
            <p>6.1.使用本服务时违反有关法律法规规定的；</p>
            <p>6.2.侵犯我们及任何第三方合法利益的；</p>
            <p>6.3.违反本协议的任何约定；</p>
            <p>6.4 其它法律和或者协议约定的违约行为。</p>
            <p><strong>6.5</strong><strong>.您确认并同意，如发生前述任一违约行为后，本公司可以采取以下一项和或多项处理措施：</strong></p>
            <p>6.5.1.采取各种技术手段予以删除、屏蔽或断开并留存相关的信息；</p>
            <p>6.5.2.中止或终止部分或全部本服务和或者法律容许的所有合理合法措施。</p>
            <p>6.5.3.未使用的充值费用和或者交付的服务费用将作为违约金归本公司所有，同时若因您的违约行为致使我们或其关联公司被追究责任或使我们或其关联公司利益受损的，您须对我们及其关联公司进行赔偿。赔偿金额包括但是不限于您因违约行为我们及其关联公司因此遭受的损失以及我们因此所需支付的包括但不限于诉讼/仲裁费用、调查费用、律师费用、公证费用等一切合理维权费用。</p>
            <p>6.5.4.若因您违约而导致您遭受任何损失（包括但不限于通信中断，用户资料、相关数据等的丢失、毁损、清空或相关服务无法使用等损失）我们不承担任何责任，且我们无义务为您或第三方提供任何内容恢复或信息备份服务；</p>
            <p><strong>七、豁免原则</strong></p>
            <p>7.1.包括但是不限于以下任何一种情形发生，可能会造成您的物流在线服务账号无法适时登录或我们无法适时向您提供本协议项下的服务，请您理解我们不承担任何责任。</p>
            <p>7.1.1.定期或不定期对本服务的相关网站、服务器进行检查或施工，更新软硬件等；</p>
            <p>7.1.2.服务器遭受损坏，无法正常运作；</p>
            <p>7.1.3.任何非我们无法控制和或者非故意的软硬件设备与电子通信设备故障，.网络线路或其他故障；</p>
            <p>7.1.4.不可抗力及其他第三方原因。</p>
            <p>7.2.我们并不担保我们所提供的服务一定能满足您的要求或符合您的期望。</p>
            <p>7.3 在法律所允许的范围内，我们不就您因使用本服务所引起的或有关的任何间接性、偶然性、惩罚性、特殊性的损害和损失承担赔偿责任，除非是我们故意所为。</p>
            <p><strong>八</strong><strong>、协议变更</strong></p>
            <p>8.1.本公司保留在您同意本协议后，根据国家法律要求，业务发展和维护使用者合法权益之情形，而不时修改本协议。您须知悉并认可和接受本条款及其他若有的其它服务协议条款会不时变更。</p>
            <p>8.2.<strong>如果您不同意我们修改的内容，您在本协议和/或其他若有的其它服务协议条款修改及更新时间后不要再使用本服务和/或其他服务的任何部分。</strong></p>
            <p><strong>但若您</strong><strong>一旦在本协议和/或其服务协议条款修改后，乃继续使用本服务和/或其服务，则确定您已理解并同意修改后的本协议和/或其他协议条款全部内容。</strong></p>
            <p><strong>九、其他</strong></p>
            <p>9.1.您确认接受后的本协议是您与我们之间关于您使用本协议项下服务所达成的法律协议文本。本协议生效日期和时间以您点击同意之日和时间为准，并对双方产生约束力。具体时间以我们系统记录的时间为准。</p>
            <p><strong>9.</strong><strong>2.若无论何种原因您没有点击"同意"（&ldquo;同意&rdquo;的具体措辞以页面载明的为准），但是您若已经实际使用我们的物流服务视为接受和认可本协议。</strong></p>
            <p><strong>9.3</strong>.本协议的任何条款因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效且有约束力。</p>
            <p style="padding-bottom: 0.4rem"><strong>至此，您确认已理解本协议，并</strong><strong>谨此</strong><strong>同意遵守本协议所有条款而使用本服务。</strong></p>
          </div>
        </div>
        <div class="modalbottom">
          <div :class="isBottom ? ' btnview showcolor' : ' btnview disabled'" @click="handShur()">
            <span>我同意</span>
          </div>
          <div class="btnview" @click="addshow = false">
            <span>不同意</span>
          </div>
        </div>
      </div>

    </div>
    <!-- 充值类型切卡 -->
    <div class="tab-container">
      <div class="tab-item" :class="{ active: rechargeType === 'package' }" @click="rechargeType = 'package'">套餐充值</div>
      <div class="tab-item" :class="{ active: rechargeType === 'custom' }" @click="rechargeType = 'custom'">自定义充值</div>
    </div>

    <!-- 套餐充值 -->
    <div class="toplist" v-if="rechargeType === 'package'">
      <p>充值金额</p>
      <div class="listall">
        <div class="listitem" v-for="(item, index) in list" :key="index" :class="{ active: index === code }"
             @click="getindex(item, index)">
          <div class="remark" v-if="item.remark">
            <span>{{ item.remark }}</span>
          </div>
          <p>¥{{ item.investMoney / 100 }}</p>
          <dl v-if="item.giftContext">{{ item.giftContext }}</dl>
        </div>
      </div>
      <dl>{{ tips }}</dl>
    </div>

    <!-- 自定义充值 -->
    <div class="toplist" v-if="rechargeType === 'custom'">
      <p>充值金额</p>
      <div class="custom-amount">
        <input type="number" v-model.number="customAmount" placeholder="请输入充值金额" min="1" step="0.01" />
        <span class="unit">元</span>
      </div>
      <dl>{{ tips }}</dl>
    </div>
    <p style="margin: 0.2rem 0.35rem; font-size: 0.32rem; text-align: left">
      支付方式
    </p>
    <md-field class="radio-field" style="padding: 0">
      <div v-for="(item, index) in banks" :key="index">
        <div class="paylinshe" v-if="item.code != 'wx'" @click="paywap(item, index)">
          <div class="listebnr">
            <img :src="item.img" alt="" />
            <span>{{ item.name }}</span>
          </div>
          <div class="lischeckj">
            <div class="serbrtn" v-if="item.isService">
              <span>{{ item.serviceFee }}%手续费</span>
            </div>
            <div class="link" v-if="item.code === 'taobao'">
              <a @click.stop="jumpUrl()">前往淘宝店铺</a>
            </div>
            <md-icon v-if="index === paycode" name="success" color="orangeRed" size="lg"></md-icon>
            <md-icon v-if="index != paycode" name="check" size="lg"></md-icon>
          </div>
          <p v-if="item.waring" class="waring">{{ item.waring }}</p>
        </div>
      </div>
    </md-field>

    <md-button type="warning" @click="pay" style="margin-top: 0.5rem">
      <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel" :size="15" color="#fff"
                             text-color="#fff"></md-activity-indicator>
      <span v-else>確認支付</span>
    </md-button>
    <div v-html="payGateWay" style="width: 100%; height: 1rem">
      {{ payGateWay }}
    </div>

    <!-- 淘宝订单号输入框 -->
    <md-dialog :closable="false" v-model="asyncDialog.open" :btns="asyncDialog.btns">
      <md-input-item type="text" preview-type="text" v-model="asyncDialog.code" title="淘宝订单号" placeholder="请输入淘宝订单号"
                     is-title-latent></md-input-item>
    </md-dialog>

  </div>
</template>
<script>
import {
  Amount,
  Field,
  RadioList,
  Button,
  Dialog,
  Toast,
  ActivityIndicator,
  InputItem
} from "mand-mobile";
import { isBlank } from "@/until/common.js";

export default {
  name: "List",
  components: {
    [Amount.name]: Amount,
    [Field.name]: Field,
    [Button.name]: Button,
    [ActivityIndicator.name]: ActivityIndicator,
    [Dialog.name]: Dialog,
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem
  },
  data() {
    return {
      list: [],
      addshow: false,
      tips: "",
      code: null, // 当前选中充值金额套餐
      payGateWay: "",
      isBottom: false,
      banks: [], // 支付方式list
      paycode: null, // 当前选中支付方式索引
      way: {}, // 当前选中支付方式
      loading: false,
      itemAre: {},
      rechargeType: 'package', // 充值类型：package（套餐充值）、custom（自定义充值）
      customAmount: null, // 自定义充值金额
      asyncDialog: {
        open: false,
        btns: [
          {
            text: "确定",
            handler: this.onBasicConfirm
          }, {
            text: "取消",
            handler: this.cancel
          },
        ],
        code: ""
      }
    };
  },
  activated() {
    this.getcreduit();
    this.payList();
  },
  methods: {
    handShur() {
      if (this.isBottom) {
        this.http.APIASK(this.ports.confirmRechargeInstructions, "get", null)
          .then(res => {
            localStorage.setItem("chongzhiid", 1);
            this.addshow = false;
          })

      }else{
        Dialog.confirm({
          title: '提示',
          content: '请确认是否已阅读完成，并同意此充值声明',
          confirmText: '我同意',
          onConfirm: () =>{
            this.http.APIASK(this.ports.confirmRechargeInstructions, "get", null)
              .then(res => {
                localStorage.setItem("chongzhiid", 1);
                this.addshow = false;
              })
          },
        })
      }

    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isBottom = true
        // 已滚动到底部
        console.log('已滚动到底部');
      }
    },
    getindex(item, index) {
      this.code = index;
      this.itemAre = item;
    },
    // 选择支付方式
    paywap(item, index) {
      this.paycode = index;
      this.way = item;
    },
    payList() {
      this.ajax.AJAx(this.ports.paywayshop, "post", {}).then(res => {
        this.banks = res;
      });
    },
    cancel() {
      this.asyncDialog.open = false
    },
    pay() {
      const { paycode } = this;

      // 验证支付方式是否选择
      if (paycode === null) {
        Toast.failed("请选择充值方式");
        return;
      }

      // 验证充值声明是否同意
      if (!localStorage.getItem("chongzhiid")) {
        this.addshow = true;
        return;
      }

      // 根据充值类型验证
      var par = {
        clientBackUrl: window.location.origin + "/#/chongzhi",
        wayId: this.way.id
      };

      if (this.rechargeType === 'package') {
        // 套餐充值验证
        if (this.code === null) {
          Toast.failed("請选择充值套餐");
          return;
        }
        par.depositId = this.itemAre.id;
      } else {
        // 自定义充值验证
        if (!this.customAmount || this.customAmount < 1) {
          Toast.failed("请输入有效充值金额");
          return;
        }
        // 将自定义金额转换为分
        par.customMoney = Math.round(this.customAmount);
      }

      if (this.way.code === "taobao") {
        // 淘宝需输入淘宝单号
        this.asyncDialog.code = "";
        this.asyncDialog.open = true;
        return false;
      }

      this.loading = true;
      this.ajax
        .AJAx(this.ports.payshopsubmit, "post", par)
        .then(res => {
          if (this.way.code === "paypal") {
            var url =
              res.clientUrl +
              "?client_id=" +
              res.paySign +
              "&custom_id=" +
              res.detail.outTradeNo +
              "&amount=" +
              res.detail.totalPrice +
              "&type=1";
            window.location.href = url;
          } else {
            this.payGateWay = res.paySign;
            var that = this;
            setTimeout(function () {
              that.loading = false;
              document.forms[0].submit();
            }, 10);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 淘宝支付 输入订单号回调
    onBasicConfirm() {
      if (isBlank(this.asyncDialog.code)) {
        Toast.failed("淘宝订单号不能为空");
        return false;
      }
      var myregs = /^[0-9]*$/;
      if (!myregs.test(this.asyncDialog.code)) {
        Toast.failed("输入有误，淘宝订单号为纯数字的编号");
        return
      }
      this.asyncDialog.open = false;

      let par = {
        clientBackUrl: window.location.origin + "/#/chongzhi",
        wayId: this.way.id,
        taoBaoCode: this.asyncDialog.code
      };

      if (this.rechargeType === 'package') {
        par.depositId = this.itemAre.id;
      } else {
        if (!this.customAmount || this.customAmount < 1) {
          Toast.failed("请输入有效充值金额");
          return;
        }
        par.customMoney = Math.round(this.customAmount);
      }

      this.loading = true;
      this.ajax
        .AJAx(this.ports.payshopsubmit, "post", par)
        .then(res => {
          this.loading = false;
          Toast.succeed('提交成功,请等待后台审核')
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getcreduit() {
      this.ajaxconfig
        .AJAxConfig(this.ports.shopDepositlist, "post", {})
        .then(res => {
          this.list = res;
        });
      this.ajaxconfig
        .AJAxConfig(this.ports.getPayWarnInfo, "post", {})
        .then(res => {
          this.tips = res;
        });
    },
    // 跳转外链
    jumpUrl() {
      let userinfo = JSON.parse(localStorage.getItem('userinfoMobie'))
      console.log()
      if (userinfo.pcShopCodeUrl) {
        window.open(userinfo.pcShopCodeUrl);
      } else {
        Toast.failed("用户暂无绑定淘宝店铺");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.toplist {
  background-color: white;

  p {
    margin-left: 5%;
    width: 90%;
    padding-top: 0.5rem;
    text-align: left;
    font-size: 0.3rem;
  }

  dl {
    width: 90%;
    margin-left: 5%;
    font-size: 0.2rem;
    line-height: 0.4rem;
    text-align: left;
    white-space: pre-line;
    padding-bottom: 0.2rem;
  }

  .listall {
    width: 90%;
    margin-left: 5%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 0.2rem;

    .listitem {
      margin-bottom: 0.2rem;
      background-color: rgba(249, 249, 249, 100);
      border: 2px solid rgba(238, 238, 238, 100);
      width: 30%;
      height: 1.5rem;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .remark {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #ff3a30;
        font-size: 0.18rem;
        color: white;
        padding: 0.05rem 0.12rem;
      }

      p {
        font-size: 0.4rem;
        font-weight: bolder;
        color: #ff3a30;
        text-align: center;
      }

      dl {
        color: #9f9f9f;
        font-size: 0.2rem;
        text-align: center;
      }
    }

    .active {
      background-color: rgba(252, 244, 233, 100);
      border: 2px solid rgba(250, 171, 28, 100);
    }
  }

  .listall:after {
    // 使用伪类元素占据单位，不影响页面
    content: "";
    height: 0;
    width: 30%;
  }
}

.paylinshe {
  width: 94%;
  margin-left: 3%;
  height: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(248, 248, 248, 100);
  position: relative;
}

.waring {
  position: absolute;
  bottom: 0.01rem;
  font-size: 0.12rem;
}

.listebnr {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 0.28rem;

  img {
    width: 0.5rem;
    height: auto;
    margin-right: 0.2rem;
  }
}

.lischeckj {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;

  .serbrtn {
    width: 1.5rem;
    height: 0.3rem;
    color: rgba(246, 57, 13, 100);
    font-size: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    border: 1px solid rgba(246, 57, 13, 100);
  }

  .link {
    color: #1890ff;
    font-size: 0.22rem;
    margin-right: 1.2rem;
  }


}

.modalDiv {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;

  .modaView {
    width: 96%;
    height: 11.5rem;
    margin-top: 1rem;
    background-color: #ffffff;
    border-radius: 0.08rem;

    .modatitle {
      height: 0.8rem;
      font-size: 0.4rem;
      display: flex;
      align-items: center;
      font-weight: bold;
      padding-left: 0.2rem;
    }

    .modalcontainer {
      width: 96%;
      margin-left: 2%;
      border: 1px solid #bbbbbb;
      border-radius: 0.08rem;
      height: 9.5rem;
      overflow-y: scroll;


    }

    .modalbottom {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 1.2rem;
      font-size: 0.28rem;

      .btnview {
        width: 1.5rem;
        height: 0.6rem;
        border: 1px solid #cccccc;
        margin: 0 0.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.08rem;
      }

      .disabled {
        color: #cccccc;
      }

      .showcolor {
        color: #ffffff;
        background: red;
        border: none;
      }
    }

  }
}
.shocoamer{
  text-align: left;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-bottom: 0.4rem;
  h1{
    font-size: 0.4rem;
  }
  p{
    font-size: 0.24rem;
    margin: 0.1rem 0;
    line-height: 0.3rem;
  }
  li{
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}
  /* 充值类型切卡样式 */
  .tab-container {
    display: flex;
    background-color: white;
    margin-bottom: 0.2rem;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 0.3rem 0;
      font-size: 0.32rem;
      color: #666;
      border-bottom: 2px solid transparent;

      &.active {
        color: #ff3a30;
        border-bottom-color: #ff3a30;
      }
    }
  }

  /* 自定义充值样式 */
  .custom-amount {
    width: 90%;
    margin-left: 5%;
    padding: 0.3rem 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;

    input {
      flex: 1;
      font-size: 0.4rem;
      border: none;
      outline: none;
      color: #ff3a30;
      font-weight: bolder;
      padding: 0.2rem;
      background-color: rgba(249, 249, 249, 100);
      border-radius: 0.08rem;

      &::placeholder {
        color: #ccc;
        font-weight: normal;
      }
    }

    .unit {
      margin-left: 0.2rem;
      font-size: 0.32rem;
      color: #666;
    }
  }
</style>
